var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderer)?_c(_vm.renderer,_vm._g({tag:"component",attrs:{"item":_vm.item,"data":_vm.data,"module":_vm.module,"is-active":_vm.isActive,"installation":_vm.installation,"module-data":_vm.moduleData}},_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }